/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestData
 */
export interface AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestData {
  /**
   * require_auth_code: 認証コード入力画面へ遷移 / skip_auth: 即閲覧画面へ遷移
   * @type {string}
   * @memberof AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestData
   */
  status?: string
}

export function AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestDataFromJSON(
  json: any
): AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestData {
  return AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestDataFromJSONTyped(json, false)
}

export function AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status']
  }
}

export function AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestDataToJSON(
  value?: AuthVisitorUnifiedFormSigninResponseVisitorVisitorContactRequestData | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status
  }
}
